import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export type FileUploadStatus = 'queued' | 'uploading' | 'success' | 'error';

/**
 * Event group for staged file-upload lifecycle mutations.
 *
 * Consumed by {@link withFileUpload} via `withReducer`.
 */
export const fileUploadEvents = eventGroup({
  source: 'fileUpload',
  events: {
    filesStaged: type<File[]>(),
    fileUnstaged: type<string>(),
    deleteStaged: type<string>(),
    deleteUnstaged: type<string>(),
    fileRetried: type<string>(),
    uploadsReset: type<void>(),
    commitStarted: type<void>(),
    commitCompleted: type<void>(),
    fileStatusChanged: type<{
      error?: string;
      id: string;
      status: FileUploadStatus;
    }>(),
  },
});
